/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/naming-convention */

export interface AsantoAffordabilityResiRequest {
  search_id: string;
  num_applicants: number;
  property_value: number;
  loan_amount: number;
  mortgage_type: string;
  property_type: string;
  applicants: AsantoApplicantResi[];
  dependants_0_to_5: number;
  dependants_6_to_11: number;
  dependants_12_to_17: number;
  dependants_18_and_over: number;
  joint_total_credit_balance: number;
  joint_annual_loan_payments: number;
}

export interface AsantoApplicantResi {
  applicant_number: number;
  date_of_birth: string;
  current_age: number;
  planned_retirement_age: number;
  employment_status: string;

  // Primary income
  annual_gross_salary: number;
  annual_net_profit_current: number;
  annual_net_profit_previous: number;
  annual_directors_salary_current: number;
  annual_directors_salary_previous: number;

  // Other Income
  annual_investment_income_guaranteed: number;
  annual_investment_income_guaranteed_percentage: number;
  annual_investment_income_non_guaranteed: number;
  annual_lir_disability_benefits: number;

  // Current retirement income
  annual_state_pension: number;
  annual_flexi_pension_record_1: number;
  annual_flexi_pension_record_percentage_1: number;
  annual_non_escalating_annuity_1: number;
  annual_non_escalating_annuity_percentage_1: number;
  annual_escalating_annuity_1: number;
  annual_escalating_annuity_percentage_1: number;
  annual_occupation_pension_record_1: number;
  annual_occupation_pension_record_percentage_1: number;

  // Future retirement income
  annual_lir_pension_benefit_record_1: number;
  annual_lir_pension_benefit_record_percentage_1: number;
  annual_lir_pension_contribution_record_1: number;
  annual_lir_pension_contribution_record_percentage_1: number;

  // Individual Commitments
  total_credit_card_balance: number;
  annual_loan_payments: number;
  annual_council_tax: number;
}
export interface AsantoAffordabilityResponse {
  quotes: AsantoQuoteResult[];
}

export interface AsantoAffordabilityResponseError {
  statusCode: string;
  message: string;
}

export interface AsantoQuoteResult {
  affordability_result: 'Pass' | 'Fail';
  maximum_affordable_loan_amount: number;
  maximum_loan_amount: number;
  interest_rate: number;
  monthly_payment: number;
  quote_number: string;
  schemeName: string;
  search_id: string;
}
